import {Component, OnInit} from '@angular/core';
import {UserService} from "../../../shared/services/user.service";
import {ActivatedRoute, Router} from '@angular/router';
import {TextService} from "../../../shared/services/text.service";
import {SdkInitText} from "../../../model/user/sdk-init-text";
import {SessionService} from "../../../shared/services/session.service";
import {NzModalService} from "ng-zorro-antd";
import {FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators} from "@angular/forms";
import {NumberModel} from "../../../model/user/number.model";
import {PasswordMatcher} from "../../../shared/utils/password-matcher-util";


@Component({
  selector: 'pa-pin-create',
  templateUrl: './pin-create.component.html',
  styleUrls: ['./pin-create.component.scss']
})
export class PinCreateComponent implements OnInit {

  numberModel: NumberModel;
  trackingId: string;
  submitted = false;
  textService: TextService;
  sdkInitTexts: Array<SdkInitText>;
  formBuilder: FormBuilder = new FormBuilder();
  errorMessage: string;

  pinForm = this.formBuilder.group({
    pin: new FormControl('', [Validators.required, Validators.minLength(6), Validators.maxLength(6)]),
    repin: new FormControl('', [Validators.required, Validators.minLength(6), Validators.maxLength(6)])
  }, { validator: PasswordMatcher('pin', 'repin') });

  constructor(private router: Router, private route: ActivatedRoute, private userService: UserService,
              private modalService: NzModalService, private sessionService: SessionService, textService: TextService) {
    this.textService = textService;
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.trackingId = params['trackingId'];
      this.numberModel = new NumberModel();
    });
  }

  createPin() {
    if (this.pinForm.invalid) {
      return;
    }
    this.numberModel.partOfOne = this.pinForm.value.pin;
    this.userService.createPin(this.numberModel, this.trackingId).subscribe(response => {
      this.submitted = true;
      this.router.navigate(['/route', this.trackingId]);
    }, error => {
      this.errorMessage = error.error.message;
    });
  }

  messageState(value: any) {
    this.errorMessage = value;
  }

}
